import React, { useState, useEffect } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./jobs.css";
import Bluebutton from "../../components/blueButton/Bluebutton";
import Latestjob from "../../components/latestjob/Latestjob";
import Arrow1 from "../../components/latestjob/Arrow1.png";
import Arrow from "./Arrow.png";
import { Link } from "react-router-dom";
import axios from "axios";
import API_URL from "../../constants";
const Jobs = () => {
  const [jobs, setJobs] = useState();
  const status = {
    status: "draft",
  };
  console.log("status", status);
  const [keyword, setKeyword] = useState("");
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [location, setLocation] = useState("");
  const [isRemote, setIsRemote] = useState(""); // Default value for remote
  const [Filtered, setFiltered] = useState([]); // Default value for remote

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Make sure yearsOfExperience is converted to an integer
      const data = {
        keywords:keyword,
        years_of_experience: parseInt(yearsOfExperience),
        location:location,
        remote:isRemote,
      };
      console.log("datassss", data);
      // Send the data to the backend
      const response = await axios.post(`${API_URL}/applications/filterJobs`, data);
      // Handle the response as needed
      console.log("response",response);
      setFiltered(response.data.filteredJobs)
      console.log("responsedata",response.data);

    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_URL}/applications/`);
      // const response = await axios.get("http://localhost:3001/admin/jobs", {
      //   params: status,
      // });
      console.log("Response:", response.data);
      setJobs(response.data.activeJobs);
      // console.log("jobs",jobs);
    } catch (error) {
      console.error("Error:", error);
      console.error("Error Response:", error.response); // Log the error response
    }
  };
  console.log("jobs", jobs);
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Navb />
      <div className="jobHeader">Search Jobs</div>
      <form onSubmit={handleSubmit}>
        <div className="jobCategorys">
          {/* <label>Keyword:</label> */}
          <input
            className="jobCategory border1"
            type="text"
            value={keyword}
            placeholder="Keyword"
            onChange={(e) => setKeyword(e.target.value)}
          />

          {/* <label>Years of Experience:</label> */}
          <input
            type="number"
            className="jobCategory"
            value={yearsOfExperience}
            placeholder="Years of Experience"
            onChange={(e) => setYearsOfExperience(e.target.value)}
          />

          {/* <label>Location:</label> */}
          <input
            type="text"
            value={location}
            className="jobCategory "
            placeholder="Location"
            onChange={(e) => setLocation(e.target.value)}
          />

          {/* <label>Remote:</label> */}
          <select
            placeholder="Mode of Work"
            value={isRemote}
            className="jobCategory border2"
            onChange={(e) => setIsRemote(e.target.value)}
          >
            <option value="" disabled >Mode of Work</option>
            <option value="remote">Remote</option>
            <option value="hybrid">Hybrid</option>
            <option value="onsite">Onsite</option>
          </select>
        </div>
        <div className="SearchBtn">
          <button type="submit">
            Search <img src={Arrow} alt="Arrow" />
          </button>
        </div>
        {/* <button type="submit">Filter Jobs</button> */}
      </form>


      <div className="latestJobContainerBorder">
        {Filtered &&
          Filtered.map((job) => (
            <Latestjob
              key={job.id}
              JobTitle={job.post}
              Location={job.location}
              data={job}
            />
          ))}
      </div>







      {/* <div className="jobCategorys">
        <div className="jobCategory border1">Categoryone</div>
        <div className="jobCategory ">Categorytwo</div>
        <div className="jobCategory">Categorythree</div>
        <div className="jobCategory border2">Categoryfour</div>
      </div>
      <div className="SearchBtn">
        <button>
          Search <img src={Arrow} alt="Arrow" />
        </button>
      </div> */}
      <div className="jobHeader">Latest Jobs</div>
      <div className="latestJobContainerBorder">
        {jobs &&
          jobs.map((job) => (
            <Latestjob
              key={job.id}
              JobTitle={job.post}
              Location={job.location}
              data={job}
            />
          ))}
      </div>
      {/* <div className="cvSubmit">
        Did not find the job you are looking for ?{" "}
        <Link to="/jobs/cv" className="submit-button">
          <div className="latestJobapply">
            <button>
              Submit Your CV <img src={Arrow1} alt="Arrow" />
            </button>
          </div>
        </Link>
      </div> */}
      {/* <div className="center">
        <Bluebutton Text="Submit" Link="contact" />
      </div> */}
      <Footer />
    </>
  );
};

export default Jobs;
